export const IconInfor = () => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.16675 13.166H9.83341V8.16602H8.16675V13.166ZM9.00008 6.49935C9.23619 6.49935 9.43425 6.41935 9.59425 6.25935C9.75369 6.0999 9.83341 5.90213 9.83341 5.66602C9.83341 5.4299 9.75369 5.23185 9.59425 5.07185C9.43425 4.9124 9.23619 4.83268 9.00008 4.83268C8.76397 4.83268 8.56619 4.9124 8.40675 5.07185C8.24675 5.23185 8.16675 5.4299 8.16675 5.66602C8.16675 5.90213 8.24675 6.0999 8.40675 6.25935C8.56619 6.41935 8.76397 6.49935 9.00008 6.49935ZM9.00008 17.3327C7.8473 17.3327 6.76397 17.1138 5.75008 16.676C4.73619 16.2388 3.85425 15.6452 3.10425 14.8952C2.35425 14.1452 1.76064 13.2632 1.32341 12.2493C0.885637 11.2355 0.666748 10.1521 0.666748 8.99935C0.666748 7.84657 0.885637 6.76324 1.32341 5.74935C1.76064 4.73546 2.35425 3.85352 3.10425 3.10352C3.85425 2.35352 4.73619 1.75963 5.75008 1.32185C6.76397 0.884627 7.8473 0.666016 9.00008 0.666016C10.1529 0.666016 11.2362 0.884627 12.2501 1.32185C13.264 1.75963 14.1459 2.35352 14.8959 3.10352C15.6459 3.85352 16.2395 4.73546 16.6767 5.74935C17.1145 6.76324 17.3334 7.84657 17.3334 8.99935C17.3334 10.1521 17.1145 11.2355 16.6767 12.2493C16.2395 13.2632 15.6459 14.1452 14.8959 14.8952C14.1459 15.6452 13.264 16.2388 12.2501 16.676C11.2362 17.1138 10.1529 17.3327 9.00008 17.3327ZM9.00008 15.666C10.8612 15.666 12.4376 15.0202 13.7292 13.7285C15.0209 12.4368 15.6667 10.8605 15.6667 8.99935C15.6667 7.13824 15.0209 5.56185 13.7292 4.27018C12.4376 2.97852 10.8612 2.33268 9.00008 2.33268C7.13897 2.33268 5.56258 2.97852 4.27091 4.27018C2.97925 5.56185 2.33341 7.13824 2.33341 8.99935C2.33341 10.8605 2.97925 12.4368 4.27091 13.7285C5.56258 15.0202 7.13897 15.666 9.00008 15.666Z'
      fill='#1C1B1F'
    />
  </svg>
);

export const IconChart = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.16667 15.5C1.70833 15.5 1.31583 15.3369 0.989167 15.0108C0.663055 14.6842 0.5 14.2917 0.5 13.8333V2.16667C0.5 1.70833 0.663055 1.31583 0.989167 0.989167C1.31583 0.663055 1.70833 0.5 2.16667 0.5H9.66667V2.16667H2.16667V13.8333H13.8333V6.33333H15.5V13.8333C15.5 14.2917 15.3369 14.6842 15.0108 15.0108C14.6842 15.3369 14.2917 15.5 13.8333 15.5H2.16667ZM3.83333 12.1667H5.5V6.33333H3.83333V12.1667ZM7.16667 12.1667H8.83333V3.83333H7.16667V12.1667ZM10.5 12.1667H12.1667V8.83333H10.5V12.1667ZM12.1667 5.5V3.83333H10.5V2.16667H12.1667V0.5H13.8333V2.16667H15.5V3.83333H13.8333V5.5H12.1667Z'
      fill='black'
    />
  </svg>
);

export const IconEmpty = () => (
  <svg
    width='74'
    height='33'
    viewBox='0 0 74 33'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_11525_31932)'>
      <rect x='22.5' y='13' width='29' height='19' fill='#EDEDED' />
      <path
        d='M22 8.5H52'
        stroke='#C0C0C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M52 8.5L45 2.5H29L22 8.5V32.5H52V8.5Z'
        stroke='#C0C0C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M41 18.5H33V8.5L36 2.5H38L41 8.5V18.5Z'
        stroke='#C0C0C0'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <line x1='54.5' y1='31' x2='65.5' y2='31' stroke='black' strokeWidth='2' />
    <line x1='8.5' y1='32' x2='19.5' y2='32' stroke='black' strokeWidth='2' />
    <line x1='0.5' y1='32' x2='4.5' y2='32' stroke='black' strokeWidth='2' />
    <line x1='68.5' y1='31' x2='73.5' y2='31' stroke='black' strokeWidth='2' />
    <g clipPath='url(#clip1_11525_31932)'>
      <path
        d='M53.5 0C49.089 0 45.5 3.589 45.5 8C45.5 12.411 49.089 16 53.5 16C57.911 16 61.5 12.411 61.5 8C61.5 3.589 57.911 0 53.5 0ZM54.4645 3.5L54 9.5H53L52.5355 3.5H54.4645ZM53.5 12.5C52.9475 12.5 52.5 12.0525 52.5 11.5C52.5 10.9475 52.9475 10.5 53.5 10.5C54.0525 10.5 54.5 10.9475 54.5 11.5C54.5 12.0525 54.0525 12.5 53.5 12.5Z'
        fill='#F0B71C'
      />
    </g>
    <defs>
      <clipPath id='clip0_11525_31932'>
        <rect
          width='32'
          height='32'
          fill='white'
          transform='translate(20.5 1)'
        />
      </clipPath>
      <clipPath id='clip1_11525_31932'>
        <rect width='16' height='16' fill='white' transform='translate(45.5)' />
      </clipPath>
    </defs>
  </svg>
);

export const AddIconInfor = () => (
  <svg
    width='14'
    height='15'
    viewBox='0 0 14 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.00004 0.833984C5.6815 0.833984 4.39257 1.22498 3.29624 1.95752C2.19991 2.69006 1.34543 3.73125 0.840847 4.94943C0.336263 6.1676 0.20424 7.50805 0.461475 8.80125C0.71871 10.0945 1.35365 11.2823 2.286 12.2147C3.21835 13.147 4.40624 13.782 5.69944 14.0392C6.99265 14.2965 8.33309 14.1644 9.55127 13.6598C10.7694 13.1553 11.8106 12.3008 12.5432 11.2045C13.2757 10.1081 13.6667 8.81919 13.6667 7.50065C13.6667 6.62517 13.4943 5.75827 13.1592 4.94943C12.8242 4.14059 12.3331 3.40566 11.7141 2.78661C11.095 2.16755 10.3601 1.67649 9.55127 1.34145C8.74243 1.00642 7.87552 0.833984 7.00004 0.833984ZM7.00004 11.5007C6.86819 11.5007 6.7393 11.4616 6.62966 11.3883C6.52003 11.315 6.43458 11.2109 6.38412 11.0891C6.33367 10.9673 6.32046 10.8332 6.34619 10.7039C6.37191 10.5746 6.4354 10.4558 6.52864 10.3626C6.62187 10.2693 6.74066 10.2059 6.86998 10.1801C6.9993 10.1544 7.13335 10.1676 7.25517 10.2181C7.37698 10.2685 7.4811 10.354 7.55436 10.4636C7.62761 10.5732 7.66671 10.7021 7.66671 10.834C7.66671 11.0108 7.59647 11.1804 7.47145 11.3054C7.34642 11.4304 7.17686 11.5007 7.00004 11.5007ZM7.66671 8.16732C7.66671 8.34413 7.59647 8.5137 7.47145 8.63872C7.34642 8.76375 7.17686 8.83398 7.00004 8.83398C6.82323 8.83398 6.65366 8.76375 6.52864 8.63872C6.40362 8.5137 6.33338 8.34413 6.33338 8.16732V4.16732C6.33338 3.99051 6.40362 3.82094 6.52864 3.69591C6.65366 3.57089 6.82323 3.50065 7.00004 3.50065C7.17686 3.50065 7.34642 3.57089 7.47145 3.69591C7.59647 3.82094 7.66671 3.99051 7.66671 4.16732V8.16732Z'
      fill='#47C751'
    />
  </svg>
);

export const QuestionIcon = () => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C0.00866568 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C40 17.3736 39.4827 14.7728 38.4776 12.3463C37.4725 9.91982 35.9993 7.71504 34.1421 5.85786C32.285 4.00069 30.0802 2.5275 27.6537 1.52241C25.2272 0.517315 22.6264 0 20 0ZM20 32C19.6044 32 19.2178 31.8827 18.8889 31.6629C18.56 31.4432 18.3036 31.1308 18.1523 30.7654C18.0009 30.3999 17.9613 29.9978 18.0384 29.6098C18.1156 29.2219 18.3061 28.8655 18.5858 28.5858C18.8655 28.3061 19.2219 28.1156 19.6098 28.0384C19.9978 27.9613 20.3999 28.0009 20.7654 28.1522C21.1308 28.3036 21.4432 28.56 21.6629 28.8889C21.8827 29.2178 22 29.6044 22 30C22 30.5304 21.7893 31.0391 21.4142 31.4142C21.0392 31.7893 20.5304 32 20 32ZM23.42 22.78C22 23.46 22 23.56 22 24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0392 25.7893 20.5304 26 20 26C19.4696 26 18.9609 25.7893 18.5858 25.4142C18.2107 25.0391 18 24.5304 18 24C18.028 22.9092 18.3985 21.8547 19.0589 20.9861C19.7194 20.1175 20.6364 19.4786 21.68 19.16C23.22 18.42 24 18 24 16C23.9999 15.6529 23.9096 15.3118 23.7377 15.0102C23.5659 14.7087 23.3186 14.457 23.02 14.28C22.1067 13.7413 21.06 13.4709 20 13.5C18.62 13.5 16 14.02 16 16C16 16.5304 15.7893 17.0391 15.4142 17.4142C15.0391 17.7893 14.5304 18 14 18C13.4696 18 12.9609 17.7893 12.5858 17.4142C12.2107 17.0391 12 16.5304 12 16C12 12.24 15.36 9.5 20 9.5C24.64 9.5 28 12.24 28 16C28.0726 17.4734 27.6654 18.9307 26.8397 20.1531C26.0139 21.3755 24.814 22.2973 23.42 22.78Z'
      fill='#17345B'
    />
  </svg>
);

export const ArrowUp = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.99998 5.40039L9.39998 7.80039H4.59998L6.99998 5.40039ZM6.99998 0.60039C6.12211 0.60039 5.29438 0.767057 4.51678 1.10039C3.73918 1.43372 3.05864 1.89212 2.47518 2.47559C1.89171 3.05906 1.43331 3.73959 1.09998 4.51719C0.766642 5.29479 0.599976 6.12252 0.599976 7.00039C0.599976 7.88946 0.766642 8.72012 1.09998 9.49239C1.43331 10.2641 1.89171 10.9417 2.47518 11.5252C3.05864 12.1087 3.73918 12.5671 4.51678 12.9004C5.29438 13.2337 6.12211 13.4004 6.99998 13.4004C7.88904 13.4004 8.71971 13.2337 9.49198 12.9004C10.2637 12.5671 10.9413 12.1087 11.5248 11.5252C12.1082 10.9417 12.5666 10.2641 12.9 9.49239C13.2333 8.72012 13.4 7.88946 13.4 7.00039C13.4 6.12252 13.2333 5.29479 12.9 4.51719C12.5666 3.73959 12.1082 3.05906 11.5248 2.47559C10.9413 1.89212 10.2637 1.43372 9.49198 1.10039C8.71971 0.767057 7.88904 0.60039 6.99998 0.60039Z'
      fill='#7A7A7A'
    />
  </svg>
);

export const ArrowDown = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.99998 8.59961L9.39998 6.19961H4.59998L6.99998 8.59961ZM6.99998 13.3996C6.12211 13.3996 5.29438 13.2329 4.51678 12.8996C3.73918 12.5663 3.05864 12.1079 2.47518 11.5244C1.89171 10.9409 1.43331 10.2604 1.09998 9.48281C0.766642 8.70521 0.599976 7.87748 0.599976 6.99961C0.599976 6.11054 0.766642 5.27988 1.09998 4.50761C1.43331 3.73588 1.89171 3.05828 2.47518 2.47481C3.05864 1.89134 3.73918 1.43294 4.51678 1.09961C5.29438 0.766276 6.12211 0.599609 6.99998 0.599609C7.88904 0.599609 8.71971 0.766276 9.49198 1.09961C10.2637 1.43294 10.9413 1.89134 11.5248 2.47481C12.1082 3.05828 12.5666 3.73588 12.9 4.50761C13.2333 5.27988 13.4 6.11054 13.4 6.99961C13.4 7.87748 13.2333 8.70521 12.9 9.48281C12.5666 10.2604 12.1082 10.9409 11.5248 11.5244C10.9413 12.1079 10.2637 12.5663 9.49198 12.8996C8.71971 13.2329 7.88904 13.3996 6.99998 13.3996Z'
      fill='#7A7A7A'
    />
  </svg>
);

export const IconIncrease = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={10}
      height={12}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M1.695 5.707l2.293-2.293V11a1 1 0 102 0V3.414L8.28 5.707a1 1 0 001.414-1.414l-4-4a1 1 0 00-1.414 0l-4 4a1 1 0 001.414 1.414z'
        fill='#41AC49'
      />
    </svg>
  );
};

export const IconDecrease = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={10}
      height={12}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M4.28 11.706a.99.99 0 00.326.217.986.986 0 00.764 0 .99.99 0 00.326-.217l4-4A1 1 0 108.28 6.293L5.988 8.586V1a1 1 0 00-2 0v7.586L1.695 6.293A1 1 0 00.28 7.707l3.999 3.999z'
        fill='#D94D27'
      />
    </svg>
  );
};

export const IconRankUp = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='11'
    height='10'
    viewBox='0 0 11 10'
    fill='none'
  >
    <g clipPath='url(#clip0_3971_5665)'>
      <path
        d='M2.75577 4.75565L4.6666 2.84482V9.16649C4.6666 9.3875 4.7544 9.59946 4.91068 9.75574C5.06696 9.91202 5.27892 9.99982 5.49993 9.99982C5.72095 9.99982 5.93291 9.91202 6.08919 9.75574C6.24547 9.59946 6.33327 9.3875 6.33327 9.16649V2.84482L8.2441 4.75565C8.40127 4.90745 8.61177 4.99145 8.83027 4.98955C9.04876 4.98765 9.25777 4.90001 9.41228 4.7455C9.56679 4.591 9.65443 4.38199 9.65633 4.16349C9.65823 3.94499 9.57423 3.73449 9.42243 3.57732L6.0891 0.243989C5.93283 0.0877628 5.7209 0 5.49993 0C5.27896 0 5.06704 0.0877628 4.91077 0.243989L1.57743 3.57732C1.42563 3.73449 1.34164 3.94499 1.34354 4.16349C1.34544 4.38199 1.43308 4.591 1.58758 4.7455C1.74209 4.90001 1.9511 4.98765 2.1696 4.98955C2.3881 4.99145 2.5986 4.90745 2.75577 4.75565Z'
        fill='#47C751'
      />
    </g>
    <defs>
      <clipPath id='clip0_3971_5665'>
        <rect width='10' height='10' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
);

export const IconRankDown = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='11'
    height='10'
    viewBox='0 0 11 10'
    fill='none'
  >
    <g clipPath='url(#clip0_3971_5871)'>
      <path
        d='M2.75577 5.24435L4.6666 7.15518V0.833511C4.6666 0.612498 4.7544 0.400537 4.91068 0.244256C5.06696 0.0879755 5.27892 0.000178337 5.49993 0.000178337C5.72095 0.000178337 5.93291 0.0879755 6.08919 0.244256C6.24547 0.400537 6.33327 0.612498 6.33327 0.833511V7.15518L8.2441 5.24435C8.40127 5.09255 8.61177 5.00855 8.83027 5.01045C9.04876 5.01235 9.25777 5.09999 9.41228 5.2545C9.56679 5.409 9.65443 5.61801 9.65633 5.83651C9.65823 6.05501 9.57423 6.26551 9.42243 6.42268L6.0891 9.75601C5.93283 9.91224 5.7209 10 5.49993 10C5.27896 10 5.06704 9.91224 4.91077 9.75601L1.57743 6.42268C1.42563 6.26551 1.34164 6.05501 1.34354 5.83651C1.34544 5.61801 1.43308 5.409 1.58758 5.2545C1.74209 5.09999 1.9511 5.01235 2.1696 5.01045C2.3881 5.00855 2.5986 5.09255 2.75577 5.24435Z'
        fill='#D94D27'
      />
    </g>
    <defs>
      <clipPath id='clip0_3971_5871'>
        <rect
          width='10'
          height='10'
          fill='white'
          transform='matrix(1 0 0 -1 0.5 10)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconBack = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
  >
    <mask
      id='mask0_250_7853'
      style={{ maskType: 'alpha' }}
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='24'
      height='24'
    >
      <rect width='24' height='24' fill='currentColor' />
    </mask>
    <g mask='url(#mask0_250_7853)'>
      <path
        d='M12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825L13.425 18.6L12 20Z'
        fill='black'
      />
    </g>
  </svg>
);